import { Expose, Transform } from 'class-transformer';
import { Model } from './model';

export class TeacherOnlineMinutesReport extends Model {
  @Expose()
  @Transform(({ value }) => (value ? new Date(value) : null))
  fromDate: Date | null;
  @Expose()
  @Transform(({ value }) => (value ? new Date(value) : null))
  toDate: Date | null;
  @Expose()
  @Transform(({ value }) => (value ? value.toFixed(2) : null))
  onlineMinutes: string | null;
  @Expose()
  @Transform(({ obj }) => (obj && obj.teacher && obj.teacher._id ? obj.teacher._id : null))
  teacherId: string | null;
  @Expose()
  @Transform(({ obj }) => (obj && obj.teacher && obj.teacher.fullName_lower ? obj.teacher.fullName_lower : null))
  teacherName: string | null;
}
